import React, { useState } from "react";
import {
  Modal,
  PrimaryBlueButton,
  PrimaryGrayButton
} from "@velaro/velaro-component-lib";
import { AzureIndex } from "../types";

interface Props {
  index: AzureIndex;
  onClose: () => void;
  onDelete: (id: number) => Promise<void>;
}

export default function DeleteIndexModal({ index, onClose, onDelete }: Props) {
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    setDeleting(true);
    try {
      await onDelete(index.id);
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Modal maxWidth="max-w-md" show={true}>
      <div className="bg-white p-6 rounded-2xl w-full">
        {/* Header */}
        <div className="mb-4">
          <h2 className="text-lg font-semibold text-red-600">Delete Index</h2>
        </div>

        {/* Content */}
        <div className="mb-6">
          <p className="text-sm text-slate-600">
            Are you sure you want to delete the index{" "}
            <span className="font-semibold">"{index.name}"</span>?
          </p>
          <p className="text-sm text-slate-500 mt-2">
            This will permanently delete the Azure Search index and all its data.
            This action cannot be undone.
          </p>
          <div className="mt-3 p-3 bg-amber-50 border border-amber-200 rounded-md">
            <p className="text-xs text-amber-700">
              <strong>Note:</strong> If any AI chatbot configurations are using
              this index, the deletion will fail. Please update those
              configurations first.
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3">
          <PrimaryGrayButton label="Cancel" onClick={onClose} />
          <button
            onClick={handleDelete}
            disabled={deleting}
            className="px-4 py-2 bg-red-600 text-white text-sm font-medium rounded-md hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {deleting ? "Deleting..." : "Delete Index"}
          </button>
        </div>
      </div>
    </Modal>
  );
}
